import { useCallback } from 'react';
import { useCopyToClipboard } from '@/shared/hooks/use-copy-to-clipboard';
import { useRevealCodexSecret } from './use-reveal-codex-secret';

type UseCopyCodexSecretResult = {
  copySecret: () => Promise<void>;
  isCopied: boolean;
  isRevealing: boolean;
};

export function useCopyCodexSecret(): UseCopyCodexSecretResult {
  const { revealCodexSecret, isRevealing } = useRevealCodexSecret();
  const { copy, isCopied } = useCopyToClipboard();

  const copySecret = useCallback(async () => {
    const secret = await revealCodexSecret();
    if (secret) await copy(secret);
  }, [copy, revealCodexSecret]);

  return { copySecret, isCopied, isRevealing };
}
